// extracted by mini-css-extract-plugin
export default {"google-button":"static-React-HVJS-HVUI-GooglePassButton-___index-module__google-button"};